<button
  type="button"
  [ngClass]="buttonClass"
  (click)="onClicked($event)"
  [disabled]="disabled"
>
  @if (iconLeft) {
    <svg-icon
      [name]="iconLeft"
      [svgStyle]="{ 'height.px': 16, 'width.px': 16 }"
    ></svg-icon>
  }
  @if (labelPath) {
    <p>
      {{ labelPath | translate }}
    </p>
  }
  @if (iconRight && !loading) {
    <svg-icon
      [name]="iconRight"
      [svgStyle]="{ 'height.px': 16, 'width.px': 16 }"
    ></svg-icon>
  }
  @if (loading) {
    <mat-spinner [diameter]="16" class="mat-spinner-color"></mat-spinner>
  }
</button>
